import { render, staticRenderFns } from "./IndagineEpidemiologicaMalattiaJakobCreutzfeldEditComponent.vue?vue&type=template&id=5087c3f9"
import script from "./IndagineEpidemiologicaMalattiaJakobCreutzfeldEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaMalattiaJakobCreutzfeldEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports